import { put, takeEvery } from 'redux-saga/effects';
import { fetchRelatedVideosApi, fetchRelatedVideosIqsApi } from './api';
import {
  RELATED_VIDEOS_REQUEST,
  relatedVideosSuccessAction,
  RELATED_VIDEOS_IQS_REQUEST,
  relatedVideosIqsSuccessAction,
} from './actions';

function* fetchRelatedVideos({ payload }) {
  let videos = payload.previousVideos;
  let totalCount = 0;
  let pageNum = 1;
  let perPage = 0;

  try {
    const response = yield fetchRelatedVideosApi(payload.videoId, payload.pageNumber);
    videos = [].concat(payload.previousVideos, response.videos);
    totalCount = response.totalCount;
    pageNum = response.pageNum;
    perPage = response.perPage;
    yield put(relatedVideosSuccessAction(videos, totalCount, pageNum, perPage));
  } catch (error) {}
}

function* fetchRelatedVideosIqs({ payload }) {
  let videos = payload.previousVideos;
  let totalCount = 0;
  let pageCursor = 1;
  let pageSize = 0;

  try {
    const response = yield fetchRelatedVideosIqsApi(payload.videoId, payload.pageCursor);
    videos = [].concat(payload.previousVideos, response.videos);
    totalCount = response.totalCount;
    pageCursor = response.pageCursor;
    pageSize = response.pageSize;
    yield put(relatedVideosIqsSuccessAction(videos, totalCount, pageCursor, pageSize));
  } catch (error) {}
}

export const relatedVideosSaga = function* () {
  yield takeEvery(RELATED_VIDEOS_REQUEST, fetchRelatedVideos);
  yield takeEvery(RELATED_VIDEOS_IQS_REQUEST, fetchRelatedVideosIqs);
};
